const authConfig = () => {
    return {
        "clientId": process.env.REACT_APP_OAUTH_CLIENT_ID,
        "redirectUri": `${window.location.origin}/oauth-callback`
    }
}

export default authConfig